import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    addSessionItemButton: {
      height: '35px',
      '&:disabled': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
      },
    },
    addSessionItemButtonIcon: {
      width: '22px',
      height: '22px',
      color: '#3C419A',
      cursor: 'pointer',
      transform: 'translateX(-10px)',
    },
  }),
);
